import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import WorkSheetButtons, { WorkSheetButtonsProps } from '../../../WorkSheetButtons'
import WorkSheetStatusBar, { WorkSheetCreateStatusBarProps, WorkSheetStatusBarNew } from '../../WorkSheetStatusBar'

type SingleWorkSheetHeaderDeciderProps = WorkSheetButtonsProps & WorkSheetCreateStatusBarProps & {}

const SingleWorkSheetHeaderDecider: React.FC<SingleWorkSheetHeaderDeciderProps> = ({...rest}) => {
    return <AppStyleDecider DefaultComponent={SingleWorkSheetHeaderDefault} NewComponent={SingleWorkSheetHeaderNew} {...rest} />
}

const SingleWorkSheetHeaderDefault: React.FC<SingleWorkSheetHeaderDeciderProps> = ({...rest}) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <WorkSheetStatusBar {...rest} />
            <WorkSheetButtons {...rest} />
        </div>
    )
}

const SingleWorkSheetHeaderNew: React.FC<SingleWorkSheetHeaderDeciderProps> = ({...rest}) => {
    return (
        <Fragment>
            <WorkSheetStatusBarNew {...rest} />
            <WorkSheetButtons {...rest} />
        </Fragment>
    )
}

export default SingleWorkSheetHeaderDecider
